<!--
  @Ability  name of an ability/power, derived from the `check` snippet in manage/SheetFields.svelte (without checkbox and border).
            `kind` of the ability (hurt, heal, …) sets --hue (global classes in pentelion.sass), which tints the text.
            Clicking the name opens the ActionCard (or the help for abilities which are no actions).
-->

<script>
		import {view} from "../client.svelte.js";
		import {protoActions} from "../core.js";
		import {show_actionCard} from "../dialogs/OptionDialog.svelte";

		let { ability, title = "" } = $props();

		function show_info(e) {
				e.preventDefault()
				e.stopPropagation()
				if (ability.ID in protoActions)
						show_actionCard(ability.ID)
				else
						view.show_help(ability.ID)
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<span class="check {ability.kind ?? ''}" {title}>
	<a href="#{ability.name}" onclick={show_info}>{ability.name}</a>
</span>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	/* light tint of the kind's hue to be readable on the dark screens */
	.check
		--chip: hsl(var(--hue, 30) 65% 72%)
		display: inline-flex
		align-items: center
		color: var(--chip)
		font-size: 14px
		cursor: pointer

	a
		color: inherit
		text-decoration: none
</style>
